module.exports = __webpack_public_path__ + "img/sankaku_98_blue.1399372a.png";